type PostHogIdentityClient = {
  _isIdentified: () => boolean;
  get_distinct_id: () => string;
  identify: (
    distinctId: string,
    properties: { email: string; name: string },
  ) => void;
  reset: () => void;
};

export type PostHogIdentityUser = {
  id: string;
  email: string;
  firstName: string | null;
  lastName: string | null;
};

export function toPostHogIdentityUser(user: {
  id: string;
  email?: string | null;
  firstName?: string | null;
  lastName?: string | null;
}): PostHogIdentityUser {
  return {
    id: user.id,
    email: user.email ?? "",
    firstName: user.firstName ?? null,
    lastName: user.lastName ?? null,
  };
}

export function getWorkosDisplayName(user: PostHogIdentityUser): string {
  const name = [user.firstName, user.lastName]
    .filter((part): part is string => Boolean(part))
    .join(" ");

  return name || user.email;
}

function isIdentifiedAs(
  posthog: PostHogIdentityClient,
  userId: string,
): boolean {
  return posthog._isIdentified() && posthog.get_distinct_id() === userId;
}

export function syncPostHogIdentity(
  posthog: PostHogIdentityClient,
  input: {
    loading: boolean;
    user: PostHogIdentityUser | null;
  },
) {
  if (input.loading) return;

  if (input.user) {
    if (isIdentifiedAs(posthog, input.user.id)) return;

    // Identify aliases the current distinct id. Reset first so a previous
    // signed-in person is not merged into the new user.
    if (posthog._isIdentified()) {
      posthog.reset();
    }

    posthog.identify(input.user.id, {
      email: input.user.email,
      name: getWorkosDisplayName(input.user),
    });
    return;
  }

  if (posthog._isIdentified()) {
    posthog.reset();
  }
}
